import { useUser } from '@clerk/nextjs';
import { useHubspotVisitorApiToken } from '@web/query/App/useHubspotVisitorApiToken';
import React from 'react';

/**
 * Fetches the Hubspot token from visitor identification
 * https://developers.hubspot.com/docs/guides/api/conversations/visitor-identification?_ga=2.213629908.1393124478.1747366270-555902818.1747366270
 * @returns The Hubspot token
 */
function FetchHubspotToken() {
  const { data: hubspotToken, isLoading } = useHubspotVisitorApiToken();
  const { user } = useUser();

  React.useEffect(() => {
    // Only proceed if we have both the token and user, and not loading
    if (!hubspotToken || !user || isLoading) return;
    window.HubSpotConversations?.widget?.load();
  }, [hubspotToken, user, isLoading]);

  return null;
}

export { FetchHubspotToken };
